import { EXERCISE_IDS } from '../utils/assessmentScoring';
import { API_BASE_URL } from './api';

import greetingEn from '../assets/audio/assessment/en/greeting.wav';
import empathyEn from '../assets/audio/assessment/en/empathy.wav';
import holdEn from '../assets/audio/assessment/en/hold.wav';
import closingEn from '../assets/audio/assessment/en/closing.wav';

import greetingZh from '../assets/audio/assessment/zh/greeting.mp3';
import empathyZh from '../assets/audio/assessment/zh/empathy.mp3';
import holdZh from '../assets/audio/assessment/zh/hold.mp3';
import closingZh from '../assets/audio/assessment/zh/closing.mp3';

const API_AUDIO_BASE = `${API_BASE_URL}/audio/assessment`;

const BUNDLED_SAMPLES = {
  en: {
    greeting: greetingEn,
    empathy: empathyEn,
    hold: holdEn,
    closing: closingEn
  },
  zh: {
    greeting: greetingZh,
    empathy: empathyZh,
    hold: holdZh,
    closing: closingZh
  }
};

const REMOTE_EXTENSIONS = ['wav', 'mp3'];

const getRemoteCandidates = (lang, exerciseId) => {
  const locale = lang === 'zh' ? 'zh' : 'en';
  const custom = (process.env.REACT_APP_VOICE_SAMPLE_BASE || '').replace(/\/$/, '');
  const bases = [...new Set([custom, API_AUDIO_BASE].filter(Boolean))];
  return bases.flatMap((base) => REMOTE_EXTENSIONS.map((ext) => `${base}/${locale}/${exerciseId}.${ext}`));
};

export const getVoiceSampleCandidates = (lang, exerciseId) => {
  const locale = lang === 'zh' ? 'zh' : 'en';
  const bundled = BUNDLED_SAMPLES[locale]?.[exerciseId];
  const candidates = bundled ? [bundled] : [];
  return [...candidates, ...getRemoteCandidates(lang, exerciseId)];
};

export const getVoiceSampleFallbackCandidates = (exerciseId) => {
  const bundled = BUNDLED_SAMPLES.en?.[exerciseId];
  const candidates = bundled ? [bundled] : [];
  return [...candidates, ...getRemoteCandidates('en', exerciseId)];
};

export const isVoiceExerciseId = (id) => EXERCISE_IDS.includes(id);
